import { Controller } from "@hotwired/stimulus";

const ROLE_COPY = {
  member: {
    title: "Membre",
    description:
      "Peut créer des fiches techniques, importer des factures et consulter les coûts.",
  },
  admin: {
    title: "Administrateur",
    description:
      "Tout ce qu’un membre peut faire, plus inviter ou retirer des collaborateurs et modifier les paramètres de l’établissement.",
  },
};

export default class extends Controller {
  static targets = ["select", "panel", "title", "description"];

  connect() {
    this.refresh();
  }

  refresh() {
    const role = this.selectTarget.value;
    const copy = ROLE_COPY[role] || ROLE_COPY.member;

    this.titleTarget.textContent = copy.title;
    this.descriptionTarget.textContent = copy.description;
    this.panelTarget.classList.remove("hidden");
  }

  hide() {
    this.panelTarget.classList.add("hidden");
  }
}
